import { render, staticRenderFns } from "./ezCms1i.vue?vue&type=template&id=b95f9412"
import script from "./ezCms1i.vue?vue&type=script&lang=js"
export * from "./ezCms1i.vue?vue&type=script&lang=js"
import style0 from "./ezCms1i.vue?vue&type=style&index=0&id=b95f9412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports